import React from "react";
import { motion } from "framer-motion";
import { Compass, MapPin, MessageSquare, Rocket, ArrowRight } from "lucide-react";

const STEPS = [
    { num: "01", icon: Compass, title: "Isi Assessment Awal", desc: "Ceritakan jenjang pendidikan, tujuan negara, jurusan, nilai, dan budget." },
    { num: "02", icon: MapPin, title: "Dapatkan Pemetaan Awal", desc: "Sistem kami membantu memberi opsi awal kampus dan negara yang sesuai." },
    { num: "03", icon: MessageSquare, title: "Konsultasi dengan Counselor", desc: "Counselor Senior akan memvalidasi pilihanmu secara personal." },
    { num: "04", icon: Rocket, title: "Mulai Proses Aplikasi", desc: "Kami bantu dari shortlist, dokumen, aplikasi, visa, sampai persiapan berangkat." },
];

export default function ProcessSteps() {
    const scrollTo = (id) => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth" });
    };
    return (
        <section className="bg-[#0A1A2F] text-white py-20 md:py-28 relative overflow-hidden" data-testid="process-section">
            <div className="absolute -top-40 -right-20 w-96 h-96 bg-[#F5A623]/15 rounded-full blur-3xl pointer-events-none" />
            <div className="max-w-7xl mx-auto px-6 md:px-12 relative">
                <div className="max-w-2xl mb-14">
                    <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/10 border border-white/20 text-xs font-semibold mb-5">
                        <span className="w-1.5 h-1.5 bg-[#F5A623] rounded-full" /> PROSES
                    </div>
                    <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight tracking-tight">
                        Mulai dari Mana?
                    </h2>
                    <p className="mt-4 text-base sm:text-lg text-slate-300 leading-relaxed">
                        Gantari Edu membuat proses kuliah luar negeri lebih terarah dalam 4 langkah.
                    </p>
                </div>

                <div className="grid md:grid-cols-4 gap-4 md:gap-5 relative">
                    {STEPS.map((s, i) => {
                        const Icon = s.icon;
                        return (
                            <motion.div
                                key={s.num}
                                initial={{ opacity: 0, y: 24 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, margin: "-60px" }}
                                transition={{ duration: 0.5, delay: i * 0.1 }}
                                className="relative bg-white/5 border border-white/10 rounded-2xl p-6 hover:border-[#F5A623] hover:bg-white/10 transition-all"
                                data-testid={`process-step-${i}`}
                            >
                                <div className="flex items-start justify-between mb-5">
                                    <div className="w-11 h-11 rounded-xl bg-[#F5A623]/15 border border-[#F5A623]/30 flex items-center justify-center">
                                        <Icon className="w-5 h-5 text-[#F5A623]" />
                                    </div>
                                    <span className="font-display text-3xl font-bold text-white/15">{s.num}</span>
                                </div>
                                <h3 className="font-display font-semibold text-lg leading-snug">{s.title}</h3>
                                <p className="mt-2 text-sm text-slate-300 leading-relaxed">{s.desc}</p>
                            </motion.div>
                        );
                    })}
                </div>

                <div className="mt-12 text-center">
                    <button
                        onClick={() => scrollTo("smart-search")}
                        data-cta="cta_process_assessment"
                        data-testid="process-cta-assessment"
                        className="inline-flex items-center gap-2 bg-[#F5A623] text-[#0A1A2F] hover:bg-[#D98F1B] rounded-full px-8 py-4 font-bold transition-all shadow-[0_4px_14px_0_rgba(245,166,35,0.45)]"
                    >
                        Mulai Assessment Gratis <ArrowRight className="w-4 h-4" />
                    </button>
                </div>
            </div>
        </section>
    );
}
